import LandingPagePanel from "./landingPagePanel.container";

export default LandingPagePanel;
